import { render, staticRenderFns } from "./zjg.vue?vue&type=template&id=c66c78fa&scoped=true&"
import script from "./zjg.vue?vue&type=script&lang=js&"
export * from "./zjg.vue?vue&type=script&lang=js&"
import style0 from "./zjg.vue?vue&type=style&index=0&id=c66c78fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66c78fa",
  null
  
)

export default component.exports